<div class="chart-container">
  <div class="chart-header" *ngIf="showExpandButton">
    <button mat-icon-button (click)="openFullscreen()">
      <mat-icon>open_in_new</mat-icon>
    </button>
  </div>

  <p-chart
    #chartRef
    class="p-chart"
    *ngIf="lineChartData"
    type="line"
    [data]="lineChartData"
    [options]="lineChartOptions">
  </p-chart>
</div>